import React, { useRef } from "react";
import { Plus, Trash2, ImageIcon } from "lucide-react";

function VariantRow({ v, i, onChange, onRemove, upload }) {
  const fileRef = useRef(null);
  const pick = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    const url = await upload(f);
    if (url) onChange({ ...v, image: url });
    e.target.value = "";
  };
  return (
    <div className="flex items-center gap-3 rounded-xl border border-white/10 p-3" data-testid={`variant-row-${i}`}>
      <button type="button" onClick={() => fileRef.current?.click()} className="w-14 h-14 rounded-lg overflow-hidden border border-white/15 flex items-center justify-center shrink-0" data-testid={`variant-image-btn-${i}`}>
        {v.image ? <img src={v.image} alt={v.name} className="w-full h-full object-cover" /> : <ImageIcon className="w-5 h-5 text-white/40" />}
      </button>
      <input ref={fileRef} type="file" accept="image/*" className="hidden" onChange={pick} data-testid={`variant-image-input-${i}`} />
      <input type="color" value={v.hex} onChange={(e) => onChange({ ...v, hex: e.target.value.toUpperCase() })} className="!w-10 !h-10 !p-0.5 rounded cursor-pointer shrink-0" data-testid={`variant-color-picker-${i}`} />
      <div className="flex-1 grid grid-cols-2 gap-2">
        <input required placeholder="Colour name" value={v.name} onChange={(e) => onChange({ ...v, name: e.target.value })} data-testid={`variant-name-${i}`} />
        <input required placeholder="#000000" pattern="^#[0-9A-Fa-f]{6}$" value={v.hex} onChange={(e) => onChange({ ...v, hex: e.target.value })} data-testid={`variant-hex-${i}`} />
        <input placeholder="Or paste image URL" value={v.image} onChange={(e) => onChange({ ...v, image: e.target.value })} className="col-span-2 !text-xs" data-testid={`variant-image-url-${i}`} />
        <label className="col-span-2 flex items-center gap-2 text-xs text-white/60">
          <input type="checkbox" className="!w-4 !h-4" checked={!!v.sold_out} onChange={(e) => onChange({ ...v, sold_out: e.target.checked })} data-testid={`variant-sold-out-${i}`} /> Sold out
        </label>
      </div>
      <button type="button" onClick={onRemove} className="text-white/40 hover:text-red-400" data-testid={`variant-remove-${i}`}><Trash2 className="w-4 h-4" /></button>
    </div>
  );
}

export default function VariantsEditor({ variants, onChange, upload }) {
  const list = variants || [];
  const update = (i, v) => onChange(list.map((x, j) => (j === i ? v : x)));
  return (
    <section data-testid="variants-editor">
      <div className="flex items-center justify-between mb-3">
        <div className="kicker">Colour Variants</div>
        <button type="button" onClick={() => onChange([...list, { name: "", hex: "#1E1B15", image: "" }])} className="text-xs inline-flex items-center gap-1 text-gold" data-testid="variant-add-btn"><Plus className="w-3.5 h-3.5" /> Add colour</button>
      </div>
      {list.length === 0 && <div className="text-xs text-white/40">No colours. Add one if this product comes in multiple finishes.</div>}
      <div className="space-y-2">
        {list.map((v, i) => <VariantRow key={i} v={v} i={i} upload={upload} onChange={(nv) => update(i, nv)} onRemove={() => onChange(list.filter((_, j) => j !== i))} />)}
      </div>
    </section>
  );
}
